import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'LongMessagePipe'
})

@Injectable()
export class LongMessagePipe implements PipeTransform {
  transform(value: any, args?: any): any {

    let length = typeof args === 'number' ? args : 20;
    let message = value.slice(0, length);

    message = (length < value.length) ? (message + '...') : message;

    return message;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/long-message.pipe.ts